import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@omilia/tooltip';

import Toggler from 'components/Toggler';

import './style.scss';

const Icons = ({ enabled, onStatusChange, onDuplicate }) => (
  /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
  <div styleName="hover-block">
    <Tooltip
      content={
        <React.Fragment>
          {enabled ? 'Disable' : 'Enable'}
          <br />
          Rule
        </React.Fragment>
      }
      placement="left"
      data-test="enable-disable-tooltip"
    >
      <div data-test="active-inactive">
        <Toggler value={enabled} onToggle={onStatusChange} />
      </div>
    </Tooltip>
    <Tooltip
      content={
        <React.Fragment>
          Duplicate
          <br />
          Rule
        </React.Fragment>
      }
      placement="left"
      data-test="duplicate-rule-tooltip"
    >
      <div styleName="duplicate">
        <span
          className="icon-duplicate rule"
          onClick={onDuplicate}
          data-test="duplicate-rule-button"
        />
      </div>
    </Tooltip>
  </div>
);

Icons.propTypes = {
  enabled: PropTypes.bool,
  onStatusChange: PropTypes.func,
  onDuplicate: PropTypes.func,
};

export default Icons;
